import React from 'react';

function Tab(props) {
  const {data, tab, setTab, tabStyle} = props;
  return (
    <>
      {data ? (
        <section className={`com_tab  ${tabStyle ? tabStyle : ``}`}>
          {data.map((item, idx) => {
            return (
              <button key={idx} className={`tab ${tab === item.value ? 'active' : ''} ${item.type ? item.type : ''}`} onClick={() => setTab(item.value)} style={item.style ? item.style : {}}>
                {item.title ? item.title : ``}
                {item.cnt ? `(` + item.cnt + `)` : ``}
              </button>
            );
          })}
        </section>
      ) : (
        <></>
      )}
    </>
  );
}

export default Tab;
